import script from "./PaginationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&setup=true&lang=js"

import "./PaginationComponent.vue?vue&type=style&index=0&id=4c223384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c223384"]])

export default __exports__